import calendars from 'scoreboard/components/calendars'
import globals from 'scoreboard/components/globals'

/**
 * Resolves the periodId/periodDelta properties for the given widget model into
 * an absolute period ID.
 *
 * @return the resolved period ID; returns null if attempting to resolve a
 * relative period and the calendar doesn't extend far enough
 */
function resolveWidgetPeriod (widgetModel) {
	var props = widgetModel.properties.toJSON()
	var currentPeriodId = widgetModel.options.getPeriodId()

	// #28846 the widget may not be configured to use the current period's
	// data; resolve the settings to a specific period ID
	let period = calendars.resolveRange({
		calendarId: props.calendarId,
		startPeriodId: props.periodId,
		endPeriodId: props.periodId,
		startPeriodDelta: props.periodDelta,
		endPeriodDelta: props.periodDelta
	}, currentPeriodId)[0]

	return period ? period.id : null
}

/**
 * Returns an appropriate error message for a calendar that doesn't extend far
 * enough.
 *
 * @param calendarIdProp ID of the calendar; if null, the current global
 * calendar will be used
 *
 * @return {{messageCode: string, arguments: [*]}} message code and arguments
 * that can be used by i18n to get a user error message
 */
function extendCalendarError (calendarIdProp) {
	let calendarId = calendarIdProp || calendars.periodsById[globals.periodId].calendar.id

	let cal = calendars.calendarsById[calendarId]
	return {
		messageCode: 'datasets.metric.snapshot.extendCalendar',
		arguments: [cal.label]
	}
}

export default resolveWidgetPeriod
export { extendCalendarError }

resolveWidgetPeriod.__filename__ = 'dashboards/widgets/resolve-widget-period.js'
